/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemInternalApiGroupReservationWaitMetricsFromJSON, StreemInternalApiGroupReservationWaitMetricsToJSON, } from './';
export function StreemInternalApiSaveGroupAverageCallLengthRequestFromJSON(json) {
    return StreemInternalApiSaveGroupAverageCallLengthRequestFromJSONTyped(json, false);
}
export function StreemInternalApiSaveGroupAverageCallLengthRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'groupSid': !exists(json, 'group_sid') ? undefined : json['group_sid'],
        'metrics': !exists(json, 'metrics') ? undefined : StreemInternalApiGroupReservationWaitMetricsFromJSON(json['metrics']),
        'updateType': !exists(json, 'update_type') ? undefined : json['update_type'],
    };
}
export function StreemInternalApiSaveGroupAverageCallLengthRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_sid': value.companySid,
        'group_sid': value.groupSid,
        'metrics': StreemInternalApiGroupReservationWaitMetricsToJSON(value.metrics),
        'update_type': value.updateType,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType;
(function (StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType) {
    StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType["CREATED"] = "WAIT_TIME_UPDATE_TYPE_CREATED";
    StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType["GROUPRESERVATIONUPDATED"] = "WAIT_TIME_UPDATE_TYPE_GROUP_RESERVATION_UPDATED";
    StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType["INVALID"] = "WAIT_TIME_UPDATE_TYPE_INVALID";
    StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType["POLLING"] = "WAIT_TIME_UPDATE_TYPE_POLLING";
    StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType["REQUEUED"] = "WAIT_TIME_UPDATE_TYPE_REQUEUED";
    StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType["USERAVAILABILITYUPDATED"] = "WAIT_TIME_UPDATE_TYPE_USER_AVAILABILITY_UPDATED";
})(StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType || (StreemInternalApiSaveGroupAverageCallLengthRequestUpdateType = {}));
//# sourceMappingURL=StreemInternalApiSaveGroupAverageCallLengthRequest.js.map